import React, {useEffect} from 'react'
import {useSelector} from 'react-redux'
import {SidebarMenuItemWithSub} from './SidebarMenuItemWithSub'
import {SidebarMenuItem} from './SidebarMenuItem'
import {UseCustom} from '../../../../partials/layout/Custom-field/Custom-field'
import {reInitMenu} from '../../../../helpers'

const SidebarMenuMain = () => {
  const modules = useSelector((state: any) => state.auth.modules) || []
  const {checkForCustomField} = UseCustom()
  const [menuItems, setMenuItems] = React.useState<any[]>([])

  useEffect(() => {
    if (modules && modules.length > 0) {
      setMenuItems([...modules])
      setTimeout(() => {
        reInitMenu()
      }, 100)
    }
  }, [modules])

  return (
    <>
      {menuItems.length > 0 ? (
        menuItems.map((item: any, parentIndex: number) => {
          const path = `/${item.title.replace(/\s+/g, '-').toLowerCase()}`

          if (item?.child?.length > 0) {
            return (
              <SidebarMenuItemWithSub
                key={`parent-${item.module_id || parentIndex}`}
                to={path}
                title={item.title}
                icon={item.icon}
              >
                {item.child.map((row: any, childIndex: number) => {
                  if (row.display_on_board) {
                    const childPath = `${path}/${row.title.replace(/\s+/g, '-').toLowerCase()}`
                    return (
                      <div
                        onClick={() => checkForCustomField(row.module_id)}
                        key={`child-${row.module_id || `${parentIndex}-${childIndex}`}`}
                      >
                        <SidebarMenuItem
                          to={childPath}
                          title={row.title}
                          icon={row.icon}
                          hasBullet={false}
                        />
                      </div>
                    )
                  }
                  return null
                })}
              </SidebarMenuItemWithSub>
            )
          }

          return (
            <div
              onClick={() => checkForCustomField(item.module_id)}
              key={`single-${item.module_id || parentIndex}`}
            >
              <SidebarMenuItem to={path} icon={item.icon} title={item.title} />
            </div>
          )
        })
      ) : (
        <div className='text-center text-muted p-4'>Loading modules...</div>
      )}
    </>
  )
}

export {SidebarMenuMain}
